import { useUserProfile } from "@/hooks/useUserProile";
import { FinancialDeckRecord } from "@/models/financialDecks";
import { CustomCellRendererProps } from "@ag-grid-community/react";

export const ModelOwnerRenderer = (props: CustomCellRendererProps) => {
  const deck = props.data as FinancialDeckRecord;
  const [profile] = useUserProfile(deck.creatorId);

  return profile?.email;
};
